var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userId || _vm.createNewUser)?_c('UserDetails',{attrs:{"userId":_vm.userId,"createNew":_vm.createNewUser}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }